import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseNoticeEnrolTitle.module.scss'

import { BOARD_TITLE_MAX_LENGTH } from '@Root/contants/myhouse'
import useBoardRegister from '@Hooks/myhouse/board/useBoardRegister'
import IconDelete22x22 from '@Ui/images/myhouse/IconDelete22x22.svg'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  handleBlur?: any
  value?: string
}

const MyhouseNoticeEnrolTitle: React.FC<Props> = ({ handleBlur, value }: Props) => {
  const [text, setText] = useState('')
  const { validateSymbols } = useBoardRegister()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!validateSymbols(event.target.value)) {
      return
    }

    if (event.target.value.length > BOARD_TITLE_MAX_LENGTH) {
      return
    }

    setText(event.target.value)
  }

  const handleDelete = () => {
    handleBlur('')
    setText('')
  }

  useEffect(() => {
    setText(value || '')
  }, [value])

  return (
    <div className={cx('myhouse_input_area')}>
      <input
        type="text"
        placeholder="제목을 입력해 주세요."
        maxLength={BOARD_TITLE_MAX_LENGTH}
        className={cx('myhouse_input_title')}
        onBlur={(event) => handleBlur(event.target.value)}
        onChange={handleChange}
        onClick={handleNclickMix(NCLICK.MY_HOUSE.NOTICE_ENROL.TITLE)}
        value={text}
      />
      {!!text && (
        <button type="button" className={cx('myhouse_delete_button')} aria-label="일괄삭제" onClick={handleDelete}>
          <IconDelete22x22 />
        </button>
      )}
    </div>
  )
}

export default MyhouseNoticeEnrolTitle
